export function parseCoordinates(longitude, latitude) {
    return parseFloat(latitude).toFixed(7) + ", " + parseFloat(longitude).toFixed(7)
}

export function displayCorrectLocation(locationName, locationIdName, longtitude, latitude) {
    if (locationName) {
        return locationName
    }
    if (locationIdName) {
        return locationIdName
    }
    if (longtitude != null && latitude != null) {
        return this.parseCoordinates(longtitude, latitude)
    }
    return ""
}
